import { render, staticRenderFns } from "./modalCalculoTempoJejum.vue?vue&type=template&id=3cb5cf56&"
import script from "./modalCalculoTempoJejum.vue?vue&type=script&lang=js&"
export * from "./modalCalculoTempoJejum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports